module.exports = __webpack_public_path__ + "static/media/carousel-01.798861f7.png";